import { isPresent } from "neetocist";
import { withT } from "neetocommons/react-utils";

import MoreDropdown from "components/MoreDropdown";

const RenameMenu = withT(
  ({
    t,
    handleRenameClick,
    disabled,
    dropdownItems,
    onArchiveStatusToggle,
    onDisableStatusToggle,
    onClone,
    onDelete,
    isArchived,
    isDisabled,
    dropdownButtonProps,
    dropdownProps,
  }) => (
    <MoreDropdown
      dropdownButtonProps={{
        "data-testid": "neeto-molecules-menu-button",
        ...dropdownButtonProps,
      }}
      dropdownProps={{
        position: "bottom-start",
        onClick: event => event.stopPropagation(),
        strategy: "fixed",
        appendTo: () => document.body,
        zIndex: "99999",
        ...dropdownProps,
      }}
      menuItems={[
        {
          "data-testid": "form-rename-button",
          onClick: handleRenameClick,
          label: t("neetoMolecules.common.actions.rename"),
          isVisible: !disabled,
          key: "edit-name-menu",
        },
        {
          "data-testid": "form-clone-button",
          onClick: onClone,
          label: t("neetoMolecules.common.actions.clone"),
          isVisible: isPresent(onClone),
          key: "clone-entity-menu",
        },
        {
          "data-testid": "form-archive-button",
          onClick: onArchiveStatusToggle,
          label: isArchived
            ? t("neetoMolecules.common.actions.unArchive")
            : t("neetoMolecules.common.actions.archive"),
          isVisible: isPresent(onArchiveStatusToggle),
          key: "archive-entity-menu",
        },
        {
          "data-testid": "form-enable-button",
          onClick: onDisableStatusToggle,
          label: isDisabled
            ? t("neetoMolecules.common.actions.enable")
            : t("neetoMolecules.common.actions.disable"),
          isVisible: isPresent(onDisableStatusToggle),
          key: "enable-entity-menu",
        },
        {
          "data-testid": "form-delete-button",
          onClick: onDelete,
          label: t("neetoMolecules.common.actions.delete"),
          isVisible: isPresent(onDelete),
          key: "delete-entity-menu",
        },
        ...dropdownItems,
      ]}
    />
  )
);

export default RenameMenu;
